export enum IDType {
    SystemCode = 'system',
    UserCode = 'user',
    OwnerCode = 'owner',
}